<!-- src/views/CreateInterview/CreateInterviewStep1.vue -->

<template>
   <el-dialog
      :model-value="dialogRegisterVisible"
      @close="$emit('close')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
      dialog-class="custom-dialog-radius"
    >
  <div class="create-interview-step">
    <div class="dialog-title">创建面试</div>
    <div class="step-bar">
      <div :class="['step-item', activeStep === 0 ? 'active' : '']">
        <span class="step-circle">1</span>
        <span class="step-label">填写基础信息</span>
      </div>
      <div class="step-line"></div>
      <div :class="['step-item', activeStep === 1 ? 'active' : '']">
        <span class="step-circle">2</span>
        <span class="step-label">连接客户端</span>
      </div>
    </div>
    <div class="step-content">
      <div v-show="activeStep === 0">
        <el-form
          ref="formRef"
          :model="formData"
          :rules="rules"
          label-width="120px"
          style="margin-top: 20px"
          label-position="top"
        >
          <el-form-item label="面试名称" prop="interviewName">
     
            <el-input
             type="textarea"
              v-model="formData.interviewName"
              maxlength="20"
              show-word-limit
              placeholder="建议格式为：面试单位-岗位-第X次面试，只能输入中英文、数字，不能包含其他特殊字符"
            ></el-input>
          </el-form-item>
          <el-form-item label="面试岗位" prop="positionInfos">
            <el-select v-model="formData.positionInfos" placeholder="请选择面试岗位">
              <el-option-group label="技术">
                <el-option label="前端开发" value="frontend"></el-option>
                <el-option label="后端开发" value="backend"></el-option>
                <el-option label="全栈开发" value="fullstack"></el-option>
                <el-option label="Android开发" value="android"></el-option>
                <el-option label="iOS开发" value="ios"></el-option>
                <el-option label="算法工程师" value="algorithm"></el-option>
                <el-option label="人工智能" value="ai"></el-option>
                <el-option label="数据工程师" value="data"></el-option>
                <el-option label="测试工程师" value="test"></el-option>
                <el-option label="运维工程师" value="devops"></el-option>
                <el-option label="安全工程师" value="security"></el-option>
                <el-option label="架构师" value="architecture"></el-option>
                <el-option label="数据库管理员" value="dba"></el-option>
                <el-option label="嵌入式开发" value="embedded"></el-option>
                <el-option label="游戏开发" value="game"></el-option>
              </el-option-group>
              <el-option-group label="产品">
                <el-option label="产品经理" value="product_manager"></el-option>
                <el-option label="产品设计师" value="product_design"></el-option>
                <el-option label="UI设计师" value="ui_design"></el-option>
                <el-option label="UX设计师" value="ux_design"></el-option>
                <el-option label="交互设计师" value="interaction_design"></el-option>
                <el-option label="视觉设计师" value="visual_design"></el-option>
                <el-option label="游戏策划" value="game_design"></el-option>
              </el-option-group>
              <el-option-group label="运营">
                <el-option label="运营专员" value="operations"></el-option>
                <el-option label="市场营销" value="marketing"></el-option>
                <el-option label="内容运营" value="content"></el-option>
                <el-option label="社区运营" value="community"></el-option>
                <el-option label="新媒体运营" value="media"></el-option>
                <el-option label="电商运营" value="ecommerce"></el-option>
                <el-option label="产品运营" value="product_operations"></el-option>
                <el-option label="用户运营" value="user_operations"></el-option>
                <el-option label="活动运营" value="activity_operations"></el-option>
                <el-option label="SEO" value="seo"></el-option>
              </el-option-group>
              <el-option-group label="销售">
                <el-option label="销售代表" value="sales"></el-option>
                <el-option label="销售经理" value="sales_manager"></el-option>
                <el-option label="大客户销售" value="key_account"></el-option>
                <el-option label="售前顾问" value="pre_sales"></el-option>
                <el-option label="渠道销售" value="channel"></el-option>
                <el-option label="商务拓展" value="bd"></el-option>
                <el-option label="客户成功" value="customer_success"></el-option>
              </el-option-group>
              <el-option-group label="职能">
                <el-option label="人力资源" value="hr"></el-option>
                <el-option label="招聘专员" value="recruiter"></el-option>
                <el-option label="人事经理" value="hrm"></el-option>
                <el-option label="HRBP" value="hrbp"></el-option>
                <el-option label="财务" value="finance"></el-option>
                <el-option label="会计" value="accounting"></el-option>
                <el-option label="法务" value="legal"></el-option>
                <el-option label="行政" value="admin"></el-option>
                <el-option label="助理" value="assistant"></el-option>
              </el-option-group>
              <el-option-group label="市场与公关">
                <el-option label="品牌公关" value="brand"></el-option>
                <el-option label="市场策划" value="marketing_planning"></el-option>
                <el-option label="市场经理" value="marketing_manager"></el-option>
                <el-option label="公关经理" value="pr"></el-option>
                <el-option label="广告投放" value="advertising"></el-option>
                <el-option label="媒介策划" value="media_planning"></el-option>
              </el-option-group>
              <el-option-group label="供应链">
                <el-option label="采购" value="purchase"></el-option>
                <el-option label="物流" value="logistics"></el-option>
                <el-option label="仓储" value="inventory"></el-option>
                <el-option label="贸易" value="trade"></el-option>
                <el-option label="供应链" value="supply_chain"></el-option>
              </el-option-group>
              <el-option-group label="教育培训">
                <el-option label="教师" value="teacher"></el-option>
                <el-option label="培训师" value="trainer"></el-option>
                <el-option label="教务管理" value="education_admin"></el-option>
                <el-option label="职业规划师" value="career_counselor"></el-option>
              </el-option-group>
              <el-option-group label="咨询">
                <el-option label="管理咨询" value="management_consulting"></el-option>
                <el-option label="财务咨询" value="financial_consulting"></el-option>
                <el-option label="IT咨询" value="it_consulting"></el-option>
                <el-option label="人力资源咨询" value="hr_consulting"></el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="代码类型" prop="programmingLanguage">
            <el-select v-model="formData.programmingLanguage" placeholder="请选择使用的代码类型">
              <el-option label="非编程面试" value="none"></el-option>
              <el-option-group label="前端">
                <el-option label="JavaScript" value="javascript"></el-option>
                <el-option label="TypeScript" value="typescript"></el-option>
                <el-option label="HTML" value="html"></el-option>
                <el-option label="CSS" value="css"></el-option>
                <el-option label="React" value="react"></el-option>
                <el-option label="Vue" value="vue"></el-option>
              </el-option-group>
              <el-option-group label="后端">
                <el-option label="Java" value="java"></el-option>
                <el-option label="Python" value="python"></el-option>
                <el-option label="Go" value="golang"></el-option>
                <el-option label="Node.js" value="nodejs"></el-option>
                <el-option label="PHP" value="php"></el-option>
                <el-option label="C#" value="csharp"></el-option>
                <el-option label="C++" value="cpp"></el-option>
              </el-option-group>
              <el-option-group label="移动端">
                <el-option label="Swift" value="swift"></el-option>
                <el-option label="Kotlin" value="kotlin"></el-option>
                <el-option label="Objective-C" value="objectivec"></el-option>
                <el-option label="Flutter" value="flutter"></el-option>
              </el-option-group>
              <el-option-group label="其他">
                <el-option label="SQL" value="sql"></el-option>
                <el-option label="Shell" value="shell"></el-option>
                <el-option label="Rust" value="rust"></el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="简历" prop="resumeText">
            <el-input
              type="textarea"
              v-model="formData.resumeText"
              maxlength="2000"
              show-word-limit
              placeholder="将您的简历文本信息粘贴至此，大模型会回答更准确"
            ></el-input>
            
          </el-form-item>
          <el-form-item label="岗位信息" prop="jobRequirements">
            <el-input
              type="textarea"
              v-model="formData.jobRequirements"
              maxlength="500"
              show-word-limit
              placeholder="将您要面试的岗位信息粘贴至此，大模型会回答更准确"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="activeStep === 1">
        <h4 style="text-align: center">
          确保您已经下载并连接电脑客户端
          <br>
          <a href="#" class="download-link" @click.prevent="goToDownload">下载地址</a>
          <a href="#" class="tutorial-link" @click.prevent="goToTutorial">使用教程</a>
        </h4>
        <el-card class="client-status-card">
          <div class="client-status-table">
            <div class="client-status-header">
              <span>您的客户端IP</span>
              <span>状态</span>
              <span>连接</span>
            </div>
            <div class="client-status-row">
              <div class="client-name">
                <el-input v-model="clientInfo.ip" placeholder="请输入IP"></el-input>
              </div>
              <div class="connection-status">
                <el-tag type="danger" v-if="!isWebsocketConnected">未连接</el-tag>
                <el-tag type="success" v-else>已连接</el-tag>
              </div>
              <div class="refresh-actions">
                <a href="#" @click.prevent="refreshClientStatus">刷新</a>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button class="primary-btn" type="primary" v-if="activeStep > 0"  @click="prevStep">上一步</el-button>
      <el-button class="primary-btn" type="primary" v-if="activeStep === 0" @click="nextStep">下一步</el-button>
      <el-button class="primary-btn" type="primary" v-if="activeStep > 0" @click="startInterview">开始面试</el-button>
    </div>
  </div>
  </el-dialog>
</template>

    


<script>
import { useRouter } from "vue-router";
import {interviewCreate} from "@/api/interview";
import { useStore } from "@/store";

const TEXT_WITH_PUNCTUATION_PATTERN = /^[\u4e00-\u9fa5a-zA-Z0-9\s.,，。！？!?:：；;（）()、\-_/\\'"“”‘’·]+$/;

export default {
  props: {
    dialogRegisterVisible: {
      type: Boolean,
      required: true
    }
  },
  components: {
    // 确保 Register 组件正确导入
    // Register
  },
  data() {
    return {
      isWebsocketConnected: false, // 用于跟踪 WebSocket 连接状态
      clientInfo: {
        ip: "", // 假设这是您的客户端名称
        isConnected: false, // 初始状态为未连接
      },
      clientList: [], // 可用的客户端列表
      isClientListLoaded: false, // 客户端列表是否已加载
      activeStep: 0,
      formData: {
        interviewId: null, // 假设这是您的面试ID
        interviewName: "",
        jobRequirements: "",
        model: "",
        programmingLanguage: "",
        resumeText: "",
        positionInfos: [],
        positionInfo: "", // 假设这是您的职位信息
        onlineMode: true,
      },
      jobOptions: [
  {
    value: "软件开发与技术",
    label: "软件开发与技术",
    children: [
      {
        value: "Web开发",
        label: "Web开发",
        children: [
          { value: "前端工程师", label: "前端工程师" },
          { value: "后端工程师", label: "后端工程师" },
          { value: "全栈工程师", label: "全栈工程师" }
        ]
      },
      {
        value: "移动端开发",
        label: "移动端开发",
        children: [
          { value: "iOS开发工程师", label: "iOS开发工程师" },
          { value: "Android开发工程师", label: "Android开发工程师" },
          { value: "跨平台开发工程师", label: "跨平台开发工程师" }
        ]
      },
      {
        value: "游戏开发",
        label: "游戏开发",
        children: [
          { value: "游戏客户端工程师", label: "游戏客户端工程师" },
          { value: "游戏服务器工程师", label: "游戏服务器工程师" },
          { value: "游戏引擎开发工程师", label: "游戏引擎开发工程师" }
        ]
      },
      {
        value: "测试与质量保障",
        label: "测试与质量保障",
        children: [
          { value: "测试工程师", label: "测试工程师" },
          { value: "性能测试工程师", label: "性能测试工程师" },
          { value: "安全测试工程师", label: "安全测试工程师" }
        ]
      },
      {
        value: "数据与算法",
        label: "数据与算法",
        children: [
          { value: "算法工程师", label: "算法工程师" },
          { value: "数据工程师", label: "数据工程师" },
          { value: "数据分析师", label: "数据分析师" }
        ]
      },
      {
        value: "系统与运维",
        label: "系统与运维",
        children: [
          { value: "运维工程师", label: "运维工程师" },
          { value: "云计算工程师", label: "云计算工程师" },
          { value: "网络安全工程师", label: "网络安全工程师" }
        ]
      },
      {
        value: "嵌入式与底层开发",
        label: "嵌入式与底层开发",
        children: [
          { value: "嵌入式开发工程师", label: "嵌入式开发工程师" },
          { value: "固件工程师", label: "固件工程师" },
          { value: "逆向工程师", label: "逆向工程师" }
        ]
      }
    ]
  },
  // 以下为其他大类结构（示例）
  {
    value: "通信/硬件/半导体",
    label: "通信/硬件/半导体",
    children: [
      {
        value: "硬件设计",
        label: "硬件设计",
        children: [
          { value: "电路设计工程师", label: "电路设计工程师" },
          { value: "PCB设计工程师", label: "PCB设计工程师" },
          { value: "电源工程师", label: "电源工程师" }
        ]
      },
      {
        value: "芯片与集成电路",
        label: "芯片与集成电路",
        children: [
          { value: "IC设计工程师", label: "IC设计工程师" },
          { value: "IC验证工程师", label: "IC验证工程师" },
          { value: "DFT工程师", label: "DFT工程师" }
        ]
      }
    ]
  },
  // ...其他大类按相同格式补充
  {
    value: "机械/制造/能源",
    label: "机械/制造/能源",
    children: [
      {
        value: "机械设计",
        label: "机械设计",
        children: [
          { value: "机械结构工程师", label: "机械结构工程师" },
          { value: "传动系统工程师", label: "传动系统工程师" }
        ]
      },
      {
        value: "新能源与材料",
        label: "新能源与材料",
        children: [
          { value: "电池工程师", label: "电池工程师" },
          { value: "材料研发工程师", label: "材料研发工程师" }
        ]
      }
    ]
  },
  {
    value: "产品与用户研究",
    label: "产品与用户研究",
    children: [
      {
        value: "产品管理",
        label: "产品管理",
        children: [
          { value: "产品经理", label: "产品经理" },
          { value: "增长产品经理", label: "增长产品经理" }
        ]
      },
      {
        value: "策略与商业化",
        label: "策略与商业化",
        children: [
          { value: "策略产品经理", label: "策略产品经理" },
          { value: "商业化产品经理", label: "商业化产品经理" }
        ]
      }
    ]
  },
  {
    value: "商分/咨询/战略",
    label: "商分/咨询/战略",
    children: [
      {
        value: "商业分析",
        label: "商业分析",
        children: [
          { value: "商业分析师", label: "商业分析师" },
          { value: "市场洞察分析师", label: "市场洞察分析师" }
        ]
      },
      {
        value: "管理咨询",
        label: "管理咨询",
        children: [
          { value: "咨询顾问", label: "咨询顾问" },
          { value: "数字化转型顾问", label: "数字化转型顾问" }
        ]
      }
    ]
  },
  {
    value: "运营与增长",
    label: "运营与增长",
    children: [
      {
        value: "用户运营",
        label: "用户运营",
        children: [
          { value: "用户增长经理", label: "用户增长经理" },
          { value: "用户生命周期管理", label: "用户生命周期管理" }
        ]
      },
      {
        value: "内容运营",
        label: "内容运营",
        children: [
          { value: "内容策略经理", label: "内容策略经理" },
          { value: "短视频运营", label: "短视频运营" }
        ]
      }
    ]
  },
  {
    value: "市场与品牌",
    label: "市场与品牌",
    children: [
      {
        value: "数字营销",
        label: "数字营销",
        children: [
          { value: "SEO/SEM专员", label: "SEO/SEM专员" },
          { value: "社交媒体运营", label: "社交媒体运营" }
        ]
      },
      {
        value: "品牌与公关",
        label: "品牌与公关",
        children: [
          { value: "品牌经理", label: "品牌经理" },
          { value: "公关媒介专员", label: "公关媒介专员" }
        ]
      }
    ]
  },
  {
    value: "职能与支持",
    label: "职能与支持",
    children: [
      {
        value: "人力资源",
        label: "人力资源",
        children: [
          { value: "招聘专员", label: "招聘专员" },
          { value: "薪酬绩效专员", label: "薪酬绩效专员" }
        ]
      },
      {
        value: "财务与法务",
        label: "财务与法务",
        children: [
          { value: "财务会计", label: "财务会计" },
          { value: "法务合规专员", label: "法务合规专员" }
        ]
      }
    ]
  }
      ],
        
      rules: {
        interviewName: [
          { required: true, message: "请输入面试名称", trigger: "blur" },
          { max: 20, message: "面试名称不超过20个字", trigger: "blur" },
          { pattern: /^[a-zA-Z0-9\u4e00-\u9fa5-]+$/, message: "请输入正确的面试名称（只能输入中英文、数字，不能包含其他特殊字符）", trigger: "blur" }
        ],
        positionInfos: [
          { required: true, message: "请选择面试岗位", trigger: "change" },
        ],
        programmingLanguage: [
          {  message: "请选择代码类型", trigger: "change" },
        ],
        resumeText: [
          { max: 2000, message: "简历内容不超过2000个字", trigger: "blur" },
          { pattern: TEXT_WITH_PUNCTUATION_PATTERN, message: "请输入正确的简历内容", trigger: "blur" }
        ],
        jobRequirements: [
          { message: "请输入岗位信息", trigger: "blur" },
          { max: 500, message: "岗位信息不超过500个字", trigger: "blur" },
          { pattern: TEXT_WITH_PUNCTUATION_PATTERN, message: "请输入正确的岗位信息", trigger: "blur" }
        ],
      },
      interviewRecords: [
        {
          interviewName: "字节算法面试xxx",
          createTime: "2024/03/19 15:30",
          duration: "30分钟",
          aiAnswerCount: 2,
          recordUrl: "https://example.com/interview-record",
        },
      ],
      totalRecords: 8,
      pageSize: 10,
      currentPage: 1,
      dialogVisible: false
    };
  },
  created() {
    this.store = useStore();
    this.formData.interviewId = this.$route.query.interviewId; // 从路由参数中获取interviewId
    
    // 从缓存中加载IP地址
    const cachedData = this.loadBoundClientFromCache();
    if (cachedData) {
      this.clientInfo.ip = cachedData.ip;
      // 注意：此时客户端列表可能还未加载，验证将在handleClientListUpdate中进行
    }
  },
  methods: {
    // 连接WebSocket 2
    connectWebsockets(connect) {
      if (connect) {
        const ip = this.clientInfo.ip;
        if(ip==''){
          //弹窗提示
          this.$message.error('请先配置客户端IP地址');
          return;
        }
        this.micWebsocket = new WebSocket(`wss://www.linkoffer.cn/ws`);
        this.setupWebsocketLifecycle(this.micWebsocket, '客户端');
      } else {

        if (this.micWebsocket) this.micWebsocket.close();
        this.micWebsocket = null;
      }
    },

    // 设置WebSocket生命周期  3
    setupWebsocketLifecycle(ws, name) {
      ws.onopen = () => {

        this.isWebsocketConnected = true;
        
        // 发送Web端认证消息
        ws.send(JSON.stringify({
          type: 'auth',
          role: 'web',
          ip: this.clientInfo.ip || '', // 如果没有IP，发送空字符串
          token: 'web_token_placeholder'
        }));

      };
      ws.onmessage = (event) => {

        
        // 判断是否为 JSON 格式
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (error) {
          // 不是 JSON，可能是心跳或普通文本，直接忽略
          if (event.data === 'pong' || event.data === 'ping') {
            return;
          }
          console.warn('收到非JSON消息:', event.data);
          return;
        }
        
        
        // 处理认证错误
        if (data.type === 'error') {
          console.error('WebSocket 认证失败:', data.message, data.code);
          // 如果是认证失败，关闭连接并提示用户
          if (data.code === 'auth-failed') {
            // 停止连接
            ws.close();
            this.isWebsocketConnected = false;
            
                         // 根据错误消息类型处理
             if (data.message === '未提供IP地址') {
               // 未提供IP地址，提示用户输入
               this.$message({
                 message: '请配置客户端IP地址',
                 type: 'warning',
                 duration: 3000,
               });
                          } else if (data.message?.includes('不在客户端列表中')) {
               // IP不在客户端列表中：提示用户重新配置
               console.warn('IP不在客户端列表中:', this.clientInfo.ip);
               this.$message({
                 message: `IP ${this.clientInfo.ip || ''}不在客户端列表中，请重新配置`,
                 type: 'error',
                 duration: 5000,
               });
            } else {
              // 其他认证错误
              this.$message({
                message: `认证失败: ${data.message || '未知错误'}`,
                type: 'error',
                duration: 3000,
              });
            }
            return;
          }
          // 其他类型的错误，继续处理
        }
        
        // 处理认证响应
        if (data.type === 'ok') {
          return;
        }
        
        // 处理client-list消息
        if (data.type === 'client-list' && data.clients) {
          this.handleClientListUpdate(data.clients);
          return;
        }
      };
      ws.onclose = () => {
        this.isWebsocketConnected = false;
      };
      ws.onerror = (error) => {
        console.error(`${name} WebSocket 错误:`, error);
        this.isWebsocketConnected = false;
      };
    },
    // 刷新客户端状态按钮点击调用 1   
    refreshClientStatus() {
      // 刷新客户端状态逻辑

      
      const ip = this.clientInfo.ip && this.clientInfo.ip.trim();
      if (!ip) {
        this.$message.error('请先输入客户端IP地址');
        return;
      }
      
      // 先建立WebSocket连接获取客户端列表，然后在handleClientListUpdate中验证IP
      this.connectWebsockets(true);
    },


    goToDownload() {
      //  this.$router.push('/Layout');
      // this.$router.push({
      //   name: "home", // 假设 Homepage 的路由名称为 'Homepage'
      //   query: { activeIndex: 4 }, // 通过 query 参数传递 activeIndex
      // });
      const routeUrl = this.$router.resolve({
        name: "home", // 假设 Homepage 的路由名称为 'Homepage'
        query: { activeIndex: 4 }, // 通过 query 参数传递 activeIndex
      });
      window.open(routeUrl.href, "_blank");
    },
    goToTutorial() {

      const routeUrl = this.$router.resolve({
        name: "home", // 假设 Homepage 的路由名称为 'Homepage'
        query: { activeIndex: 2 }, // 通过 query 参数传递 activeIndex
      });
      window.open(routeUrl.href, "_blank");
    },
    handleResumeChange(file) {
      this.formData.resumeText = file.raw;
    },
    nextStep() {
     
      // 调用表单校验
      this.$refs.formRef.validate((valid) => {
      if (valid) {
        // 校验通过，执行下一步（例如切换 activeStep）
        this.activeStep = 1;
      } else {
        // 校验不通过，提示错误（Element UI 会自动显示表单项的错误信息）
        this.$message.error('请填写正确信息');
        return false;
      }
    });
    },
    prevStep() {
      if (this.activeStep > 0) {
        this.activeStep--;
      }
    },
    async startInterview() {
      // 开始面试逻辑
      // 验证客户端IP
       const ip = this.clientInfo.ip && this.clientInfo.ip.trim();
       if (!ip) {
         this.$message.error('请先配置客户端IP地址');
         return;
       }
       // 验证连接状态，如果未连接则不能创建面试
       if (!this.isWebsocketConnected) {
         this.$message.error('客户端未连接，请先刷新连接状态');
         return;
       }

       const obj = Object.assign({}, this.formData);

      obj.positionInfo = this.formData.positionInfos

      const response = await interviewCreate(obj)
      if (response.code === 200) {
         this.formData.interviewId = response.data.interviewId; 
         if (this.formData.interviewId) {
          const interview = {
            interviewId: this.formData.interviewId,
            interviewName: this.formData.interviewName
          }
          this.store.interviewList.push(interview);
         }
        }
      this.$router.push({
        name: 'CreateInterviewStep2',
        query: { interviewId: this.formData.interviewId,
          ip: this.clientInfo.ip
         }
      });
      // this.$router.push("/create-interview/step2");
      
      // 断开WebSocket连接
      this.connectWebsockets(false);
    },
    copyUrl() {
      const url = "www.https://xxxxx";
      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.$message.success("链接已复制");
        })
        .catch(() => {
          this.$message.error("复制失败，请手动复制");
        });
    },
    
    // IP缓存管理方法（与CreateInterviewStep2.vue保持一致）
    saveBoundClientToCache(ip) {
      const cacheData = {
        ip: ip,
        timestamp: Date.now(),
        expiry: 3 * 60 * 60 * 1000 // 3小时的有效期（毫秒）
      };
      localStorage.setItem('boundClientId', JSON.stringify(cacheData));
    },
    
    loadBoundClientFromCache() {
      try {
        const cachedData = localStorage.getItem('boundClientId');
        if (!cachedData) {
          return null;
        }

        const cacheData = JSON.parse(cachedData);
        const now = Date.now();
        
        // 检查缓存是否过期
        if (now - cacheData.timestamp > cacheData.expiry) {

          localStorage.removeItem('boundClientId');
          return null;
        }


        return cacheData;
      } catch (error) {
        console.error('加载IP缓存失败:', error);
        // 如果解析失败，清除无效的缓存
        localStorage.removeItem('boundClientId');
        return null;
      }
    },
    
    clearBoundClientCache() {
      localStorage.removeItem('boundClientId');
      this.clientInfo.ip = '';

    },
    
         // 处理客户端列表更新 4
     handleClientListUpdate(clients) {

       this.clientList = clients;
       this.isClientListLoaded = true;
       // 如果验证通过且IP不为空，保存到缓存
       if (this.clientInfo.ip) {
         this.saveBoundClientToCache(this.clientInfo.ip);

       }
       
       // 如果当前没有绑定客户端，且列表不为空，可以提示用户选择
       if (!this.clientInfo.ip && clients.length > 0) {
         console.log('检测到可用客户端，可以开始配置连接');
       }
     }
  },
  setup() {
    const router = useRouter();
    return {
      router,
    };
  },
};
</script>

<style scoped>
.create-interview-step {
  /* width: 500px; */
  /* background: #fff; */
  /* border-radius: 16px; */
  /* box-shadow: 0 8px 32px rgba(0,0,0,0.12); */
  /* margin: 0 auto; */
  padding: 0px 8px 8px 8px;
}
.dialog-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
}
.step-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.step-item {
  display: flex;
  align-items: center;
}
.step-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #e6f0ff;
  color: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 6px;
}
.step-item.active .step-circle {
  background: #409eff;
  color: #fff;
}
.step-label {
  font-size: 15px;
  font-weight: 500;
}
.step-line {
  width: 40px;
  height: 2px;
  background: #e6f0ff;
  margin: 0 10px;
}
:deep(.el-form-item__label) {
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #1f2329 !important;
  display: block;
  margin-bottom: 8px;
}
.required {
  color: #f53f3f;
  margin-left: 4px;
  font-weight: 600;
}
.input-tip {
  color: #999;
  font-size: 12px;
  margin-top: 2px;
}
.input-count {
  color: #bbb;
  font-size: 12px;
  text-align: right;
  margin-top: 2px;
}
.primary-btn {
  width: 120px;
  height: 40px;
  border-radius: 8px;
  background: #409eff;
  color: #fff;
  font-size: 16px;
  /* margin: 0 auto; */
  /* display: block; */
  border: none;
}
.el-form-item {
  margin-bottom: 12px;
}

.el-upload__tip {
  font-size: 12px;
  color: #999;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
}

.download-link,
.tutorial-link {
  margin-left: 10px;
  color: #409eff;
  text-decoration: underline;
}

.url-section {
  display: flex;
  margin-left: 10px;
  /* justify-content: space-between; */
  align-items: center;
}

.client-status-card {
  margin-top: 20px;
}

.client-status-table {
  display: flex;
  flex-direction: column;
}

.client-status-header,
.client-status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.client-status-header span {
  flex: 1;
  text-align: center;
  padding: 0 8px;
}

.client-status-row div {
  flex: 1;
  text-align: center;
  padding: 0 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.client-name {
  text-align: center;
  justify-content: center;
}

.client-name .el-input {
  width: 100%;
  max-width: 200px;
}

.connection-status {
  text-align: center;
  justify-content: center;
}

.refresh-actions {
  text-align: center;
  justify-content: center;
}

.refresh-actions a {
  color: #409eff;
  text-decoration: none;
}
.custom-dialog-radius .el-dialog__body {
  border-radius: 86px;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .el-dialog {
    width: 95vw !important;
    max-width: 95vw !important;
    margin: 2.5vw auto !important;
  }
  
  .create-interview-step {
    padding: 20px 16px;
  }
  
  .dialog-title {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
  
  .step-bar {
    margin-bottom: 24px;
  }
  
  .step-item {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  
  .step-circle {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
  
  .step-label {
    font-size: 13px;
    text-align: center;
  }
  
  .step-line {
    width: 30px;
    height: 2px;
    margin: 0 8px;
  }
  
  :deep(.el-form-item__label) {
    font-size: 13px !important;
    margin-bottom: 6px;
  }
  
  :deep(.el-input__inner) {
    height: 40px;
    font-size: 14px;
  }
  
  :deep(.el-select) {
    width: 100%;
  }
  
  .primary-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
    margin-top: 20px;
  }
  
  .dialog-footer {
    flex-direction: column;
    gap: 12px;
    margin-top: 20px;
  }
  
  .download-link,
  .tutorial-link {
    margin-left: 0;
    margin-top: 8px;
    text-align: center;
    display: block;
  }
  
  .url-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-left: 0;
  }
  
  .client-status-card {
    margin-top: 16px;
  }
  
  .client-status-header,
  .client-status-row {
    font-size: 12px;
    padding: 8px 4px;
  }
  
  .client-status-header span,
  .client-status-row div {
    padding: 0 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .client-name .el-input {
    max-width: 120px;
  }
  
  .refresh-actions a {
    font-size: 12px;
    padding: 4px 8px;
  }
  
  .input-tip,
  .input-count {
    font-size: 11px;
  }
  
  .el-upload__tip {
    font-size: 11px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .el-dialog {
    width: 80vw !important;
    max-width: 80vw !important;
  }
  
  .create-interview-step {
    padding: 24px 20px;
  }
  
  .dialog-title {
    font-size: 1.6rem;
  }
  
  .step-item {
    gap: 10px;
  }
  
  .step-circle {
    width: 30px;
    height: 30px;
  }
  
  .step-label {
    font-size: 14px;
  }
  
  :deep(.el-input__inner) {
    height: 42px;
    font-size: 15px;
  }
  
  .primary-btn {
    width: 140px;
    height: 42px;
    font-size: 15px;
  }
  
  .client-status-header,
  .client-status-row {
    font-size: 13px;
    padding: 10px 6px;
  }
  
  .client-status-row div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .client-name .el-input {
    max-width: 160px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .el-dialog {
    width: 98vw !important;
    max-width: 98vw !important;
    margin: 1vw auto !important;
  }
  
  .create-interview-step {
    padding: 16px 12px;
  }
  
  .dialog-title {
    font-size: 1.3rem;
    margin-bottom: 16px;
  }
  
  .step-bar {
    margin-bottom: 20px;
  }
  
  .step-circle {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
  
  .step-label {
    font-size: 12px;
  }
  
  .step-line {
    width: 25px;
    margin: 0 6px;
  }
  
  :deep(.el-form-item__label) {
    font-size: 12px !important;
    margin-bottom: 4px;
  }
  
  :deep(.el-input__inner) {
    height: 38px;
    font-size: 13px;
  }
  
  .primary-btn {
    height: 40px;
    font-size: 15px;
    margin-top: 16px;
  }
  
  .dialog-footer {
    margin-top: 16px;
  }
  
  .client-status-header,
  .client-status-row {
    font-size: 11px;
    padding: 6px 2px;
  }
  
  .refresh-actions a {
    font-size: 11px;
    padding: 3px 6px;
  }
  
  .input-tip,
  .input-count {
    font-size: 10px;
  }
  
  .el-upload__tip {
    font-size: 10px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .el-dialog {
    width: 90vw !important;
    max-width: 90vw !important;
    max-height: 90vh !important;
    overflow-y: auto;
  }
  
  .create-interview-step {
    padding: 20px 16px;
  }
  
  .step-item {
    flex-direction: row;
    align-items: center;
    gap: 6px;
  }
  
  .step-circle {
    width: 26px;
    height: 26px;
    font-size: 12px;
  }
  
  .step-label {
    font-size: 13px;
  }
  
  .step-line {
    width: 20px;
    margin: 0 6px;
  }
  
  .primary-btn {
    width: 120px;
    height: 38px;
    font-size: 14px;
  }
  
  .dialog-footer {
    flex-direction: row;
    gap: 16px;
  }
}

/* placeholder文字颜色和大小设置 */
:deep(.el-input__inner::placeholder) {
  color: #b8b2b2 !important;
  font-size: 14px !important;
}

:deep(.el-textarea__inner::placeholder) {
  color: #b8b2b2 !important;
  font-size: 14px !important;
}

:deep(.el-select .el-input__inner::placeholder) {
  color: #b8b2b2 !important;
  font-size: 14px !important;
}

/* 移动端placeholder字体大小调整 */
@media (max-width: 768px) {
  :deep(.el-input__inner::placeholder) {
    font-size: 13px !important;
  }
  
  :deep(.el-textarea__inner::placeholder) {
    font-size: 13px !important;
  }
  
  :deep(.el-select .el-input__inner::placeholder) {
    font-size: 13px !important;
  }
}

/* 小屏手机placeholder字体大小 */
@media (max-width: 480px) {
  :deep(.el-input__inner::placeholder) {
    font-size: 12px !important;
  }
  
  :deep(.el-textarea__inner::placeholder) {
    font-size: 12px !important;
  }
  
  :deep(.el-select .el-input__inner::placeholder) {
    font-size: 12px !important;
  }
}
</style>